Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useReducedMotion = useReducedMotion;
var _PlatformChecker = require("../PlatformChecker");
var IS_REDUCED_MOTION = (0, _PlatformChecker.isReducedMotion)();
function useReducedMotion() {
    return IS_REDUCED_MOTION;
}
